import * as React from 'react';

import TwoColumnVideo from 'components/TwoColumnVideo';
import useLiveData from 'hooks/useLiveData';
import { useStaticQuery, graphql } from 'gatsby';

const TwoColumnVideoProvider = (props) => {
	const data = useStaticQuery(graphql`
		query twoColumnVideos {
		  allSmartTagsTwoColumnVideo {
		    edges {
		      node {
		        id
		        orientation
		        flush
				background
				backgroundImage
				backgroundProps
				padding
		        thumbnail
				videoLoop
				video
		        title
		        body
		      }
		    }
		  }
		}
	`);
	const {response} = useLiveData({
		namespace: 'SmartTags',
		model: 'TwoColumnVideo',
		method: 'all',
		staticData: data,
		graphqlKey: 'allSmartTagsTwoColumnVideo',
	});
	if (response.data.length === 0)return null;
	let attr;
	for (let item of response.data) {
		if (item.id === props.id)attr = item;
	}
	if (!attr)return null;
	return <TwoColumnVideo {...attr} />
}

export default TwoColumnVideoProvider;